let ENV = process.env.NODE_ENV;
let version = '1.0';
if (Boolean(VERSION)) {
  version = VERSION;
}

if (window.origin && window.origin.indexOf('staging') !== -1) ENV = 'staging';

var rollbarConfig = {
  accessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
  captureUnhandledRejections: true,
  captureUncaught: true,
  environment: ENV,
  payload: {
    environment: ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: version,
        guess_uncaught_frames: true
      }
    }
  },
  ignoredMessages: [
    'Network error: Network request failed with status 200 - "OK"', // This is when a logged out user tries to load data from graphql
    'Error: Network error: Response not successful: Received status code 401', // This is when a logged out user tries to load data from graphql catched in graphql errors,
    'Error: Network error: cancelled'
  ]
};

const rollbar = require('Scripts/rollbar.umd.nojson.min.js').init(rollbarConfig);

try {
  const userData = JSON.parse(userDataJson);
  const currentUser = userData.currentUser;

  rollbar.configure({
    payload: {
      person: {
        id: currentUser.id,
        username: currentUser.displayName,
        email: currentUser.email
      }
    }
  });
} catch (e) {}

export default rollbar;
